__turbopack_context__.v({
  "className": "geist_mono_67ecc8e3-module__lJ9sBq__className",
  "variable": "geist_mono_67ecc8e3-module__lJ9sBq__variable",
});
